// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_80ad21f8ef--tabs--3Qi3a"};